!function () {
  'use strict';

  class CartBar extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('product-info') || this.closest('.section-padding') || document.querySelector('product-info');
      this.form = this.section ? this.section.querySelector('[data-product-form]') : document.querySelector('[data-product-form]');
      this.formWrapper = (theme.settings.productPageSticky && this.section && this.section.querySelector('[data-form-wrapper]')) || this.form;
      this.handleProductAddError = this.handleProductAddError.bind(this);
      this.boundToggleCartBarOnScroll = this.toggleCartBarOnScroll.bind(this);
      this.boundSetCartBarHeight = this.setCartBarHeight.bind(this);
    }

    connectedCallback() {
      this.setCartBarHeight();
      this.addEventListener('click', this.handleClick.bind(this));
      document.addEventListener('theme:scroll', this.boundToggleCartBarOnScroll);
      window.addEventListener('scroll', this.boundToggleCartBarOnScroll, { passive: true });
      document.addEventListener('theme:resize', this.boundSetCartBarHeight);
      document.addEventListener('theme:product:add-error', this.handleProductAddError);
      this.toggleCartBarOnScroll();
    }

    handleClick(event) {
      const buttonATC = event.target.closest('[data-cart-bar-add-to-cart]');

      if (buttonATC) {
        event.preventDefault();

        buttonATC.classList.add('is-loading');
        buttonATC.setAttribute('disabled', 'disabled');

        const productForm = this.form && this.form.closest('product-form');
        if (productForm && typeof productForm.onSubmitHandler === 'function') {
          productForm.onSubmitHandler(event);
        }
        return;
      }

      if (event.target.closest('[data-cart-bar-scroll]')) {
        event.preventDefault();
        this.scrollToOptions();
      }
    }

    handleProductAddError() {
      if (this.querySelector('[data-cart-bar-add-to-cart]')) {
        this.scrollToOptions();
      }
    }

    // Scrolls the page up to the product info/options area so the
    // customer can pick a variant before adding to cart.
    scrollToOptions() {
      const scope = this.section || document;
      const target =
        scope.querySelector('variant-selects') ||
        scope.querySelector('[data-variant-picker]') ||
        scope.querySelector('[data-product-form]') ||
        scope.querySelector('[data-form-wrapper]') ||
        this.section;

      if (!target) return;

      const offset = theme.isMobile ? 10 : 30;
      const stickyHeader = document.querySelector('[data-header-sticky]');
      const headerEl = document.querySelector('[data-header-height]');
      const headerHeight = stickyHeader && headerEl ? headerEl.offsetHeight : 0;
      const top = target.getBoundingClientRect().top + window.scrollY - headerHeight - offset;

      // Scroll via the scrolling element, not window.scrollTo —
      // disable-autoscroll.js no-ops window.scrollTo and scrollIntoView globally.
      const scroller = document.scrollingElement || document.documentElement;
      if (typeof scroller.scrollTo === 'function') {
        scroller.scrollTo({ top: top, left: 0, behavior: 'smooth' });
      } else {
        scroller.scrollTop = top;
      }
    }

    toggleCartBarOnScroll() {
      const anchor = this.form || this.formWrapper;
      if (!anchor) return;

      // Show the bar only once the product form's buy button has scrolled
      // out of the viewport; hide it again when the form is back in view.
      const pastForm = anchor.getBoundingClientRect().bottom < 0;
      this.classList.toggle('is-visible', pastForm);
    }

    setCartBarHeight() {
      const cartBarHeight = this.offsetHeight;
      document.documentElement.style.setProperty('--cart-bar-height', `${cartBarHeight}px`);
    }

    disconnectedCallback() {
      document.removeEventListener('theme:product:add-error', this.handleProductAddError);
      document.removeEventListener('theme:scroll', this.boundToggleCartBarOnScroll);
      window.removeEventListener('scroll', this.boundToggleCartBarOnScroll);
      document.removeEventListener('theme:resize', this.boundSetCartBarHeight);
    }
  }

  customElements.get('cart-bar') || customElements.define('cart-bar', CartBar);
}();
